module.exports = __webpack_public_path__ + "static/media/teoria-dos-arcos@2x3.28f2c7bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/EVisual/Players/teoria-dos-arcos@2x3.jpg
// module id = 308
// module chunks = 0